var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-checkbox',{attrs:{"value":1,"unchecked-value":0},on:{"change":function($event){return _vm.updateValue()}},model:{value:(_vm.model.include_serving),callback:function ($$v) {_vm.$set(_vm.model, "include_serving", $$v)},expression:"model.include_serving"}},[_vm._v(" Incluir valores por porción. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }